export var dictionary = {
  days: ['сут', 'дня', 'дней', 'мес'],
  services: ['услуга', 'услуги', 'услуг'],
  connected: ['Подключена', 'Подключены', 'Подключено'],
  monthRULocale: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
};
export var BALANCE_TYPES = {
  Personal: 'Personal',
  CAC: 'CAC',
  Additional: 'Additional',
  UB: 'UB'
};
export var REFILLABLE_TYPES = {
  Personal: BALANCE_TYPES.Personal,
  CAC: BALANCE_TYPES.CAC,
  UB: BALANCE_TYPES.UB
};
export var PAYLOAD_STATUS_DICTIONARY = {
  SUCCESS: 'Success',
  FAIL: 'Failure'
};
export var fubTexts = {
  balanceListModal: {
    title: 'балансы'
  },
  membersBannerTitle: {
    available: 'делиться и управлять',
    master: 'делюсь и управляю',
    slave: {
      single: 'состою в группе',
      multy: 'состою в группах'
    },
    error: 'делиться и управлять'
  },
  appModal: {
    title: {
      master: 'управляйте номерами\n в приложении',
      available: 'добавляйте номера\n в приложении',
      slave: 'просматривайте группы\n в приложении',
      default: 'добавляйте номера\n в приложении'
    },
    subtitle: 'здесь пока не получится',
    qrCode: {
      lightTheme: 'https://static.beeline.ru/upload/images/app-22969.svg',
      darkTheme: 'https://static.beeline.ru/upload/images/22631_app_qr_code.png'
    },
    text: 'сканируй, чтобы скачать или перейти'
  },
  avatar: {
    default: 'https://static.beeline.ru/upload/images/app/22686_group.svg',
    fttb: 'https://static.beeline.ru/upload/images/carnica/icons/23010_ic_carnica_wifi.svg',
    mobile: 'https://static.beeline.ru/upload/images/carnica/icons/23010_user.svg',
    smart: 'https://static.beeline.ru/upload/images/carnica/icons/23010_ic_carnica_clock.svg'
  },
  storeIconLinks: ['https://static.beeline.ru/upload/images/b2c/icons/22988_AppStoreDark.svg', 'https://static.beeline.ru/upload/images/b2c/icons/22988_GoogleStore.svg', 'https://static.beeline.ru/upload/images/b2c/icons/22988_HuaweiStore.svg', 'https://static.beeline.ru/upload/images/b2c/icons/22988_RuStore.svg'],
  error: 'баланс не загрузился — <br>нажмите, чтобы обновить',
  bonusBalance: {
    title: 'бонусный баланс',
    btnText: 'хорошо'
  }
};
export var EXCLUDED_KEYS = ['membersCount', 'groupsCount'];
export var MEMBERS_TEXT = ['участник', 'участника', 'участников'];
export var MAX_MEMBERS_COUNT = 3;
export var CTN_TYPE = {
  SMART: 'smart',
  FTTB: 'fttb',
  MOBILE: 'mobile'
};
export var REDUCER_ERROR_BLOCK = {
  title: 'Что-то пошло не по плану',
  description: 'Обновите страницу или приходите позднее',
  src: 'https://static.beeline.ru/upload/images/elk/index_page_block_load_error.svg'
};
export var SUBSCRIPTION_TYPES = {
  partnerSubscriptions: 'partner-subscriptions',
  subscriptions: 'subscriptions',
  services: 'services'
};
export var UB_STATUSES = {
  CREATION_AVAILABLE: 'Available',
  // Создание общего баланса доступно для клиента (еще не создан)
  CREATED_AND_IS_OWNER: 'Master',
  // Общий баланс создан as const, это номер управляющего
  CREATED_AND_IS_SLAVE: 'Slave',
  // Общий баланс создан as const, это дочерний присоединенный номер
  CREATION_NOT_AVAILABLE: 'Deny' // Создание общего баланса недоступно для клиента
};
export var UNIFIED_PRODUCT_DEEP_LINK = 'https://mybee.page.link/unifiedProduct';